import React from "react";
import { LinearProgress } from "@mui/material";
import MDDataGrid from "components/MDDataGrid/MDDataGrid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import EmptyTableRowOverlay from "components/MDEmptyOverlay/EmptyTableRowOverlay";
import { formatDateWithTimezone } from "global/functions";

const DisputesTable = ({
  disputesList = [],
  totalDisputes = 0,
  loading = false,
  page = 0,
  pageSize = 10,
  startDate,
  endDate,
  onPageChange,
  onPageSizeChange,
}) => {
  const columns = [
    {
      field: "stripeDisputeId",
      headerName: "Dispute ID",
      width: 200,
      renderCell: ({ row }) => (
        <MDTypography variant="caption">{row.stripeDisputeId}</MDTypography>
      ),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 160,
      renderCell: ({ row }) => (
        <MDTypography variant="caption">
          {formatDateWithTimezone(row.createdAt)}
        </MDTypography>
      ),
    },
    {
      field: "evidenceDueBy",
      headerName: "Evidence Due By",
      width: 160,
      renderCell: ({ row }) =>
        row.evidenceDueBy ? (
          <MDTypography variant="caption">
            {formatDateWithTimezone(row.evidenceDueBy)}
          </MDTypography>
        ) : (
          <MDTypography variant="caption">—</MDTypography>
        ),
    },

    {
      field: "paymentIntentId",
      headerName: "Payment Intent",
      width: 200,
      renderCell: ({ row }) => (
        <MDTypography variant="caption">{row.paymentIntentId}</MDTypography>
      ),
    },
    {
      field: "chargeId",
      headerName: "Charge ID",
      width: 200,
      renderCell: ({ row }) => (
        <MDTypography variant="caption">{row.chargeId}</MDTypography>
      ),
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 120,
      renderCell: ({ row }) => (
        <MDTypography variant="caption">
          ${(row.amount / 100).toFixed(2)}
        </MDTypography>
      ),
    },
    { field: "currency", headerName: "Currency", width: 100 },
    { field: "reason", headerName: "Reason", width: 150 },
    { field: "status", headerName: "Status", width: 120 },
  ];

  return (
    <MDBox px={2}>
      {(startDate || endDate) && (
        <MDBox mb={1} display="flex" alignItems="center" gap={1}>
          <MDTypography variant="button" fontWeight="medium">
            Showing disputes from:
          </MDTypography>
          {startDate && (
            <MDTypography variant="caption">
              {new Date(startDate).toLocaleDateString()}
            </MDTypography>
          )}
          <MDTypography variant="caption">—</MDTypography>
          {endDate && (
            <MDTypography variant="caption">
              {new Date(endDate).toLocaleDateString()}
            </MDTypography>
          )}
        </MDBox>
      )}

      <MDDataGrid
        rows={disputesList}
        rowCount={totalDisputes}
        columns={columns}
        getRowId={(row) => row.stripeDisputeId}
        disableSelectionOnClick
        loading={loading}
        pagination
        paginationMode="server"
        paginationModel={{ page, pageSize }}
        rowsPerPageOptions={[10, 25, 50, 100]}
        onPaginationModelChange={({ page: newPage, pageSize: newSize }) => {
          onPageChange(newPage);
          onPageSizeChange(newSize);
        }}
        components={{
          NoRowsOverlay: EmptyTableRowOverlay,
          LoadingOverlay: LinearProgress,
        }}
        // autoHeight
      />
    </MDBox>
  );
};

export default DisputesTable;
